import * as React from "react";
import MuiAccordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import Checkbox from "@mui/material/Checkbox";
import Box from "@mui/material/Box";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { styled as styled_mui } from "@mui/material/styles";
import durationIcon from "../../../../../assets/images/duration-icon.svg";
import TickIcon from '@mui/icons-material/CheckRounded';
import { OPTIONS } from "../../Constants";
import { OPTIONS_LABEL } from "../../Constants";
import rightTick from "../../../../../assets/images/green-circle-tick.svg";
import "./QuestionList.scss";
import { truncateWithEllipsis } from "../../../../atoms/Tiptap/constants";
const INTEGER = "INT_OUTPUT_BASED";
const CustomCheckBox = styled_mui(Checkbox)({
  "&.Mui-checked": {
    color: "#123FBC",
    boxShadow: "none",
  },
});

const Accordion = styled_mui((props) => <MuiAccordion {...props} />)(
  ({ theme }) => ({
    "&:nth-child(2n+1)": {
      background: "#F8F9FD",
    },
    "& .MuiCollapse-root": {},
  })
);
const AccordionSummary = styled_mui((props) => (
  <MuiAccordionSummary {...props} />
))(({ theme }) => ({}));
export default function QuestionList({
  type,
  questionList,
  setQuestionList,
  selectedQuestion,
  setSelectedQuestion, 
  topic, 
  currentPage, 
  questionPerPage, 
  selectTopicModal
}) {
  const [questionArr, setQuestionArr] = React.useState([]);
  const [expanded, setExpanded] = React.useState(false);
  const [viewCodeExpanded, setViewCodeExpanded] = React.useState({status: false, panel: ""});
  const handleChange = (panel) => (event, isExpanded) => {
    if(!isExpanded) {
      setViewCodeExpanded({status: false, panel: ""});
    }
    setExpanded(isExpanded ? panel : false);
  };

  const handleViewCode = (panel) => (e) => {
    e.stopPropagation();
    e.preventDefault();
    setViewCodeExpanded({status: true, panel: panel});
    setExpanded(panel);
  };

  const handleHideCode = (e) => {
    e.stopPropagation();
    e.preventDefault();
    setViewCodeExpanded({status: false, panel: ""});
  };

  const handleCheckbox = (item)=>{

      let obj = selectedQuestion?.find(data=>data?.questionId===item?.id); 
     if(!obj?.questionId)
     {
      
       obj = {
            isChecked : true,
            question : item,
            questionId : item?.id
       }
       selectedQuestion?.push(obj);
      }
      else
      {
        obj.isChecked = !obj?.isChecked;
      }
     if(selectTopicModal.selectedTopic && selectTopicModal.selectedTopic?.length >0)
     {
       obj.question.topic = selectTopicModal.selectedTopic;
      }
     setSelectedQuestion(()=>{
      return [...selectedQuestion];
    });
  }

  React.useEffect(()=>{
    if(questionList && questionList?.length > 0) {
      let arr = [];
      questionList?.map((item, index) => {
        let flag = selectedQuestion?.find(ques=>ques?.questionId===item?.id)?.question?.topic && topic && selectedQuestion?.find(ques=>ques?.questionId===item?.id)?.question?.topic !== topic
        if(!flag) 
          arr.push(item);
      })
      setQuestionArr(arr);
    }
  },[selectedQuestion, questionList])
  
  return (
    <div className="question-bank-accordion">
      {questionArr && questionArr?.length > 0
        ? questionArr?.map((item, index) => {
            return (
              <>
             <Accordion
                expanded={expanded === "panel" + (index + 1)}
                onChange={handleChange("panel" + (index + 1))}
                sx={{ overflowX: 'hidden' }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content"
                  id="panel1bh-header"
                >
                 <Box width="95%" display="flex" alignItems="flex-start" justifyContent="space-between" gap="16px">
                  <Box display="flex" alignItems="flex-start" gap="6px" minWidth="100%">
                      <Typography className="col-style zero-col">
                        <CustomCheckBox
                          checked={selectedQuestion?.find(ques=>ques?.questionId===item?.id)?.isChecked?"checked":""}
                          size="small"
                          onChange={(e) => {
                            setExpanded(false);
                            handleCheckbox(item);
                          }}
                          color="primary"
                        />
                      </Typography>
                      &nbsp;&nbsp;
                      <Box width="100%" display='flex' gap="10px" justifyContent='space-between' alignItems='center'>
                      <Box>
                        <Box display="flex" alignItems="flex-start" gap="20px" justifyContent={"space-between"} width="100%">
                          <Typography className="font-style  col-style first-col font-13 font-400 d-flex rich-text-statement" maxWidth='100%'>
                            {" "}
                            {(currentPage * questionPerPage) + index + 1}.&nbsp;&nbsp;
                            <Box dangerouslySetInnerHTML={{__html: expanded !== `panel${index+1}` ? truncateWithEllipsis(item?.question_text, 100) : item?.question_text || ""}} ></Box>
                          </Typography>   
                      </Box>
                      {item?.question_code && item?.question_code?.length > 0 && <Box ml="16px">
                        {viewCodeExpanded?.status && viewCodeExpanded?.panel === "panel"+(index+1) ?
                          <pre className="mb-0 ws-pwrap">
                            <Box backgroundColor="#EBF1FF" width='fit-content' padding="6px 12px" borderRadius='8px' fontSize={12}>
                              {item?.question_code}
                            </Box>
                            <Box className="view-code-box" onClick={handleHideCode}>Hide Code</Box>
                          </pre>:
                          <Box className="view-code-box" onClick={handleViewCode("panel" + (index + 1))}>View Code</Box>
                        }
                       </Box>
                      }
                        <Box display="flex" alignItems="center" gap="8px" flexWrap="wrap" ml="16px">
                          <Typography className={`question-difficulty ${item?.difficulty_level === "EASY"?'fg-easy bg-easy':item?.difficulty_level === "MEDIUM"?"fg-medium bg-medium":"fg-hard bg-hard"}`}>{item?.difficulty_level}</Typography>
                        {
                          item?.type && item?.type?.length > 0 ? 
                          <Box>
                            <span className="dot">&#8226;</span>&nbsp;
                          <Typography display="inline-block" className="skill-badge">
                            {item?.type}
                            </Typography>
                          </Box>  
                          : null
                        }

                        {
                          item?.skill?.skill_name && item?.skill?.skill_name?.length > 0 ? 
                          <Box>
                            <span className="dot">&#8226;</span>&nbsp;
                          <Typography display="inline-block" className="skill-badge">
                          {item?.skill?.skill_name}
                            </Typography>
                          </Box>  
                          : null
                        }

                        {
                          item?.tags && item?.tags?.length > 0 ? 
                          <Box display="flex" gap="4px" lineHeight={1}>
                            <Box className="dot">&#8226;</Box>
                            <Typography display="inline-block" className="font-11 font-400 font-style ">
                              {item?.tags?.join(", ")}
                            </Typography>
                          </Box> : ""
                        }

                        </Box>
                      </Box>
                      <Box className="column-box">
                        <Typography className="role second-col">
                          {item?.role?.length>0 ? item?.role : ""} 
                          &nbsp;
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                  </Box> 
                </AccordionSummary>
                <AccordionDetails>
                      <Box className='option-box'>
                        <Typography fontSize={14}>
                          Ans.
                        </Typography>
                        {item?.type === INTEGER ?
                          <Box className="ml-20">
                            {item?.answer_json[0]}
                          </Box>
                          :
                          <ol type="a" className='options-text'>
                            {Object.entries(item?.options_json)?.map(([option, value]) => {
                              return (
                                <li>{" "}<pre>{value}{item?.answer_json?.includes(OPTIONS_LABEL[option]) && <img src={rightTick} className="right-tick" />}</pre></li>
                              )
                            })}
                          </ol>
                        }
                      </Box>
                  <Typography className="collapse-content font-style font-13 font-400">
                    {item?.question?.name && item?.question?.name?.length > 0
                      ? item?.question?.statement
                      : item?.solution?.solution1?.approach?item?.solution?.solution1?.approach:""}
                  </Typography>
                </AccordionDetails>
              </Accordion> 
              </>
            );
          })
        : ""}
    </div>
  );
}
